<!-- Header -->
<page-header
    icon="{{['SEO', 'SUMMARY'] | monIcons}}"
    header="{{'SEO Issues Summary' | translate}}">
    <page-header-content>
        <div class="d-flex justify-content-end">
            <div class="col-xs-48 text-right">
                <csv-export-button category="seo_checkpoints" clsMargin=" "></csv-export-button>
            </div>
        </div>
    </page-header-content>
</page-header>
<!-- Doughnut Chart -->
<div class="row">
    <div class="col-48 col-md-24">
        <div class="card panel-monsido-card" *ngIf="loading">
            <div class="card-body">
                <div class="row outer-b-xlarge">
                    <div class="col-48 text-center">
                        <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="card panel-monsido-card" *ngIf="loading">
            <div class="card-body">
                <div class="row outer-b-xlarge">
                    <div class="col-48 text-center">
                        <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        </div>
        <seo-summary-common-opportunities *ngIf="!loading"></seo-summary-common-opportunities>
        <seo-summary-opportunities-in-category
            *ngIf="!loading && hasAllPageCounters()"
            [alertPageCount]="pageAlerts"
            [warningPageCount]="pageWarnings"
            [infoPageCount]="pageInfos"
            [technicalPageCount]="pageTechnicals"
            [pageCount]="totalPages">
        </seo-summary-opportunities-in-category>
    </div>
    <div class="col-48 col-md-24">
        <div class="card panel-monsido-card">
            <div class="card-header" *ngIf="!loading">
                <h2 class="font-weight-300 mb-1" translate>SEO Diagnostics</h2>
                <span class="text-grey" translate>Percentage shows number of pages that are compliant with all SEO checks</span>
            </div>
            <div class="card-body">
                <div class="row outer-b-xlarge" *ngIf="loading">
                    <div class="col-48 text-center">
                        <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
                    </div>
                </div>
                <mon-chart-dashboard
                    *ngIf="!loading"
                    [progress]="chartProgress"
                    [doughnutLabels]="doughnutLabels"
                    [doughnutData]="doughnutData"
                    [doughnutOptions]="doughnutOptions"
                    [doughnutColors]="doughnutColors"
                    [lineLabels]="lineChartLabels"
                    [lineData]="lineChartData"
                    [lineSeries]="lineChartSeries"
                    [lineColors]="lineColors"
                    [lineOverride]="lineOverride"
                    [lineOptions]="lineOptions"
                    [verticalData]="verticalData"
                    [cards]="chartCardsList">
                </mon-chart-dashboard>
            </div>
            <div class="card-footer bg-white text-right" *ngIf="showHistory">
                <a class="btn-link" uiSref="base.customer.domain.changesHistory" [uiParams]="historyCenterParameters" translate>
                    Show history
                </a>
            </div>
        </div>
    </div>
</div>


<!-- Loading State -->
<div class="loading-container" *ngIf="loading">
    <div class="text-center">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
        <p translate>Loading...</p>
    </div>
</div>
